import { ROUTES } from "@/constants/routeConstants";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { selectActiveFirm } from "@/store/appSelectors";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FormSchemaType, TemplateMetaForm } from "./form/TemplateMetaForm";
import { addTemplate } from "@/sideEffects/api";
import { useMutation } from "@tanstack/react-query";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { showApiError } from "@/lib/toast";
import { parseViewportSize } from "@/components/canvas/utils/viewportUtils";
import { createEmptyCanvas } from "@/components/canvas/helpers/canvasHelpers";
import { BaseFormLayout } from "../shared/BaseFormLayout";

export const AddNewTemplatePage = () => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  useBreadcrumbs([
    { path: ROUTES.TEMPLATES, name: t("entities.template") },
    { path: ROUTES.TEMPLATE_ADD, name: t("common.addNewEntity", { entity: t("entities.template") }) },
  ]);

  const { goToTemplateEditor } = useAppNavigate();

  const addTemplateMutation = useMutation({
    mutationFn: (values: FormSchemaType) => {
      const { width, height } = parseViewportSize(values.viewportSize);
      return addTemplate({
        name: values.name,
        viewport_size: values.viewportSize,
        firmGuid: String(activeFirm?.firmGuid),
        canvas_data: createEmptyCanvas(width, height),
      });
    },
    onSuccess: (data) => {
      goToTemplateEditor(data.data.guid);
    },
    onError: showApiError,
  });

  return (
    <BaseFormLayout title={t("common.addNewEntity", { entity: t("entities.template") })}>
      <TemplateMetaForm
        buttonText={t("common.add")}
        onSubmit={(values) => addTemplateMutation.mutate(values)}
        isLoading={addTemplateMutation.isPending}
      />
    </BaseFormLayout>
  );
};
